import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  creditTypes: [],
  listPagination: {},
  creditType: {},
  fetchingCreditTypes: FETCH_STATE.UNSENT,
  fetchingCreditType: FETCH_STATE.UNSENT,
  createCreditType: FETCH_STATE.UNSENT,
  updateCreditType: FETCH_STATE.UNSENT,
  deleteCreditType: FETCH_STATE.UNSENT,
};

const creditTypesReducer = createReducer(initialState)({
  //GET CREDIT TYPES
  [types.FETCH_CREDIT_TYPES_REQUEST]: (state) => {
    return {
      ...state,
      creditTypes: [],
      fetchingCreditTypes: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_CREDIT_TYPES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      creditTypes: payload.data,
      listPagination: payload.pagination,
      fetchingCreditTypes: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_CREDIT_TYPES_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingCreditTypes: FETCH_STATE.ERROR,
    };
  },

  // GET CREDIT TYPE BY ID
  [types.FETCH_CREDIT_TYPE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      creditType: {},
      fetchingCreditType: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_CREDIT_TYPE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      creditType: payload.data,
      fetchingCreditType: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_CREDIT_TYPE_BY_ID_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingCreditType: FETCH_STATE.ERROR,
    };
  },

  // CREATE CREDIT TYPE
  [types.CREATE_CREDIT_TYPE_REQUEST]: (state) => {
    return {
      ...state,
      createCreditType: FETCH_STATE.LOADING,
    };
  },
  [types.CREATE_CREDIT_TYPE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      creditType: payload,
      createCreditType: FETCH_STATE.DONE,
    };
  },
  [types.CREATE_CREDIT_TYPE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      createCreditType: FETCH_STATE.ERROR,
    };
  },

  // DELETE CREDIT TYPE
  [types.DELETE_CREDIT_TYPE_REQUEST]: (state) => {
    return {
      ...state,
      deleteCreditType: FETCH_STATE.LOADING,
    };
  },
  [types.DELETE_CREDIT_TYPE_SUCCESS]: (state) => {
    return {
      ...state,
      deleteCreditType: FETCH_STATE.DONE,
    };
  },
  [types.DELETE_CREDIT_TYPE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      deleteCreditType: FETCH_STATE.ERROR,
    };
  },

  // UPDATE CREDIT TYPE
  [types.UPDATE_CREDIT_TYPE_REQUEST]: (state) => {
    return {
      ...state,
      updateCreditType: FETCH_STATE.LOADING,
    };
  },
  [types.UPDATE_CREDIT_TYPE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      creditType: payload,
      updateCreditType: FETCH_STATE.DONE,
    };
  },
  [types.UPDATE_CREDIT_TYPE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      updateCreditType: FETCH_STATE.ERROR,
    };
  },
  [types.UPDATE_CREDIT_TYPE_RESET]: (state) => {
    return {
      ...state,
      createCreditType: FETCH_STATE.UNSENT,
      updateCreditType: FETCH_STATE.UNSENT,
    };
  },

  // RESET REDUCER
  [types.RESET_CREDIT_TYPE]: (state) => {
    return {
      ...initialState,
    };
  },
});

export default creditTypesReducer;
